import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { suggestEmailFix } from '../../utils/emailSuggest';

/** Alan adı yazım hatası varsa "şunu mu demek istediniz?" satırı; dokununca adres düzelir */
const EmailSuggestion = ({ email, onApply, className = '' }) => {
  const suggestion = suggestEmailFix(email);
  if (!suggestion) return null;
  return (
    <p
      role="status"
      className={`flex items-start gap-1.5 text-xs font-medium text-amber-700 dark:text-amber-300 ${className}`}
    >
      <AlertTriangle size={14} className="shrink-0 mt-px" aria-hidden />
      <span className="min-w-0">
        Bunu mu demek istediniz:{' '}
        <button
          type="button"
          onClick={() => onApply(suggestion)}
          className="font-bold underline break-all text-left"
        >
          {suggestion}
        </button>
        ?
      </span>
    </p>
  );
};

export default EmailSuggestion;
